import { prop } from '@ipfabric/utils/fp/prop';
import { compareSnapshot } from 'components/Graph/commands/compareSnapshot';
import { useLocale } from 'containers/App/LocaleContext';
import { memo } from 'react';
import { useGraphContextSelectors } from '../GraphContext';

const BareGraphSameSnapshotsOverlay = () => {
  const msg = useLocale();
  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
  });

  const handleButtonClick = () => {
    ctxProps.dispatch(compareSnapshot, { snapshotToCompareId: null });
  };

  return (
    <div className='graph__overlay z-popup flex flex-col justify-center'>
      <h3 className='pb-5 text-center'>
        {msg.canvasGraph.compareSameSnapshotsOverlay.comparingSameSnapshot}
      </h3>
      <div className='text-center'>
        <button
          type='button'
          className='btn btn-default'
          onClick={handleButtonClick}
        >
          {msg.canvasGraph.compareSameSnapshotsOverlay.cancel}
        </button>
      </div>
    </div>
  );
};

export const GraphSameSnapshotsOverlay = memo(BareGraphSameSnapshotsOverlay);
